export const ACTION_LOAD_TEMPLATE_CONFIG_PREPARATION__REQUEST = 'ACTION_LOAD_TEMPLATE_CONFIG_PREPARATION__REQUEST';
export const ACTION_LOAD_TEMPLATE_CONFIG_PREPARATION__FAIL = 'ACTION_LOAD_TEMPLATE_CONFIG_PREPARATION__FAIL';
export const ACTION_LOAD_TEMPLATE_CONFIG_PREPARATION__SUCCESS = 'ACTION_LOAD_TEMPLATE_CONFIG_PREPARATION__SUCCESS';

export const ACTION_TEMPLATE_CONFIG_SET_FILE__REQUEST = 'ACTION_TEMPLATE_CONFIG_SET_FILE__REQUEST';
export const ACTION_TEMPLATE_CONFIG_SET_FILE__FAIL = 'ACTION_TEMPLATE_CONFIG_SET_FILE__FAIL';
export const ACTION_TEMPLATE_CONFIG_SET_FILE__SUCCESS = 'ACTION_TEMPLATE_CONFIG_SET_FILE__SUCCESS';

export const ACTION_TEMPLATE_CONFIG_RESET_FILE__REQUEST = 'ACTION_TEMPLATE_CONFIG_RESET_FILE__REQUEST';
export const ACTION_TEMPLATE_CONFIG_RESET_FILE__FAIL = 'ACTION_TEMPLATE_CONFIG_RESET_FILE__FAIL';
export const ACTION_TEMPLATE_CONFIG_RESET_FILE__SUCCESS = 'ACTION_TEMPLATE_CONFIG_RESET_FILE__SUCCESS';
